module.exports = __webpack_public_path__ + "img/sitemap.7658fcdb.svg";